import React from 'react'
import SydInput from '../../../../../commonDesign/SydInput'

function TitleFieldInput (props) {
  return (
    <SydInput size='sm' {...props} />
  )
}

export default TitleFieldInput
